import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const createWorklog = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/worklog/createWorklog", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateWorklog = async (
  companyId: string,
  companyType: string,
  id: number,
  payload: Record<string, any>
) =>
  post("projectService/worklog/updateWorklog", {
    company_id: companyId,
    company_type: companyType,
    id,
    ...payload,
  });

export const deleteWorklog = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/worklog/deleteWorklog", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const listByIssue = async (
  companyId: string,
  companyType: string,
  issueId: number
) =>
  post("projectService/worklog/listByIssue", {
    company_id: companyId,
    company_type: companyType,
    issue_id: issueId,
  });

export const listByUser = async (
  companyId: string,
  companyType: string,
  filters: Record<string, any> = {}
) =>
  post("projectService/worklog/listByUser", {
    company_id: companyId,
    company_type: companyType,
    ...filters,
  });
